import { render, staticRenderFns } from "./exhibition-info.vue?vue&type=template&id=faa71118&scoped=true&"
import script from "./exhibition-info.vue?vue&type=script&lang=js&"
export * from "./exhibition-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa71118",
  null
  
)

export default component.exports